
































































































import { EnterpriceBankData } from '@/store/interfaces/company';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'UsdBankForm',
  props: {
    value: {
      required: true,
      type: Object as PropType<EnterpriceBankData>,
    },
  },
  computed: {
    bankAccount: {
      get(): EnterpriceBankData {
        return this.value;
      },
      set(value: EnterpriceBankData): void {
        this.$emit('input', value);
      },
    },
  },
});
